module.exports = __webpack_public_path__ + "static/media/big_calc.85f112d0.png";